export default __webpack_public_path__ + "static/media/collage.c94c78e0.jpg";